import api from '@services/api';
import { BranchResponse } from '../models/branch';
import { PaginationResponse } from '../models/pagination';

export const BranchsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    BranchsAll: builder.query<PaginationResponse<BranchResponse>, string | void>({
      query: (input) => {
        const searchTerm = input ?? ''; // se undefined, usa string vazia
        return {
          url: `/indirect/branch/search?searchTerm=${searchTerm}&page=0&size=10&sortKey=name&sortDirection=ASC`,
        };
      },
      providesTags: ['BranchsAll'],
    }),
  }),
});

export const { useBranchsAllQuery } = BranchsApi;
